export default __webpack_public_path__ + "static/media/impact.d081e429.svg";